<!--NAV-->
<footer class="fixed_footer foo-n">
    <div class="row">
        <div class="col contenti">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/apps-foot.png" alt="">
        </div>
        <div class="col contentf">
            <h3>Sobre Triidy</h3>
            <p>Triidy es una empresa con gran capacidad de cambio, que conecta el conocimiento de los más tesos, de los
                rebeldes, de esas personas que nunca paran de aprender, para crear, probar, medir y escalar servicios
                innovadores que beneficien a nuestra
                comunidad.
            </p>
        </div>
        <div class="col contentf">
            <h3>Redes Sociales</h3>
            <ul>
                <li><a href="https://www.facebook.com/TriidySoft/" target="_blank"><i
                            class="fab fa-facebook-f fa-2x"></i></a></li>
                <li><a href="https://www.instagram.com/triidysoft/" target="_blank"><i
                            class="fab fa-instagram fa-2x"></i></a></li>
                <li><a href="https://www.youtube.com/channel/UCGrTukq5ehAgP84ak3PdU7g" target="_blank"><i
                            class="fab fa-youtube fa-2x"></i></a></li>
            </ul>
            <h3>Contenido</h3>
            <p><a class="term" routerLink="/registro-mensajero">Trabaja con Nosotros</a></p>
            <p><a class="term" routerLink="/politica-datos-personales">Políticas de privacidad</a></p>
            <p><a class="term" routerLink="/terminos-condiciones">Terminos & Condiciones</a></p>
        </div>

    </div>
</footer>

<!--MOBILE-->
<footer class="fixed_footer foo-m">
    <div class="contentf">
        <div class="row">
            <h3>Sobre Triidy</h3>
            <p>Triidy es una empresa con gran capacidad de cambio, que conecta el conocimiento de los más tesos, de los
                rebeldes, de esas personas que nunca paran de aprender, para crear, probar, medir y escalar servicios
                innovadores que beneficien a nuestra
                comunidad.
            </p>
        </div>
    </div>
    <div class="contents">
        <div class="row">
            <div class="col">
                <h3>Redes Sociales</h3>
                <ul>
                    <li><a href="https://www.facebook.com/TriidySoft/" target="_blank"><i
                                class="fab fa-facebook-f fa-lg"></i></a></li>
                    <li><a href="https://www.instagram.com/triidysoft/" target="_blank"><i
                                class="fab fa-instagram fa-lg"></i></a></li>
                    <li><a href="https://www.youtube.com/channel/UCGrTukq5ehAgP84ak3PdU7g" target="_blank"><i
                                class="fab fa-youtube fa-lg"></i></a></li>
                </ul>
            </div>
            <div class="col contenido">
                <h3>Contenido</h3>
                <p><a class="term" routerLink="/registro-mensajero">Trabaja con Nosotros</a></p>
                <p><a class="term" routerLink="/politica-datos-personales">Políticas de privacidad</a></p>
                <p><a class="term" routerLink="/terminos-condiciones">Terminos & Condiciones</a></p>
            </div>
        </div>
    </div>
    <div class="contenti">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/apps-foot.png" alt="">
    </div>
</footer>